import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import Pagination from "react-js-pagination";
export default function Pagenation(props) {
    const { page, handlePage } = props;
    return (_jsx(_Fragment, { children: _jsx(Pagination, { activePage: page.pageNum + 1, itemsCountPerPage: page.size, totalItemsCount: page.pageNum > 0 ? page.totalElements : page.totalElements + 1, pageRangeDisplayed: 10, prevPageText: "〈", nextPageText: "〉", firstPageText: "", lastPageText: "", onChange: handlePage }) }));
}
